import script from "./TressCheckoutServicePoint.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCheckoutServicePoint.vue?vue&type=script&lang=ts&setup=true"

import "./TressCheckoutServicePoint.vue?vue&type=style&index=0&id=7820b39f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7820b39f"]])

export default __exports__